export * from './lib/package-summary/package-summary-dialog.component';
